import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import querystring from 'query-string';
import labelRequest from '../labelRequest';

export default function getPrimaryWishlist(wishlistConfigs) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, options = {} } = wishlistConfigs;

    invariant(baseUrl, 'baseUrl is a required param of getPrimaryWishlist()');
    invariant(brandId, 'brandId is a required param of getPrimaryWishlist()');
    invariant(country, 'country is a required param of getPrimaryWishlist()');
    invariant(uberToken, 'uberToken is a required param of getPrimaryWishlist()');
    invariant(clientId, 'clientId is a required param of getPrimaryWishlist()');

    const headers = { 'Content-Type': 'application/json' };

    const optionalQuery = options && Object.keys(options).length > 0 ? `?${querystring.stringify(options)}` : '';

    const fetchUrl = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wishlist/v2/@default${optionalQuery}`;

    return labelRequest(
        authenticatedRequest(new Request(fetchUrl, { headers: new Headers(headers), method: 'GET' }), uberToken, clientId, clientSecret),
        'getPrimaryWishlist',
    );
}
